export enum SpSliderBulletSize {
    small,
    big,
}
